import { createPinia } from 'pinia'
// import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

const _pinia = createPinia()
// _pinia.use(piniaPluginPersistedstate)

export const pinia = _pinia

export * from './api'
export { useFormStore } from './formStore'
export { useUploadStore } from './uploadStore'
export * from './messaging'

